import React, { useEffect, useState } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

const HighChartDonutChart = (props) => {
    const { chartOptions, seriesData = [] } = props;
    const [updatedChartOptions, setUpdatedChartOptions] = useState({
        ...chartOptions,
        series: [
            {
                name: null,
                data: seriesData?.map((item) => ({
                    name: item.name,
                    y: item.y,
                    count: item.count,
                })),
                size: '100%',
                innerSize: '50%',
                showInLegend: true,
                borderRadius: 0,
            }
        ],
    });

    useEffect(() => {
        setUpdatedChartOptions({
            ...chartOptions,
            series: seriesData.length > 0 ? [
                {
                    name: null,
                    data: seriesData?.map((item) => ({
                        name: item.name,
                        y: item.y,
                        count: item.count,
                    })),
                    size: '100%',
                    innerSize: '50%',
                    showInLegend: true,
                    borderRadius: 0,
                }
            ] : [],
        });
    }, [seriesData]);

    return <HighchartsReact highcharts={Highcharts} options={updatedChartOptions} />;
}

export default HighChartDonutChart;
